import { Controller } from "@hotwired/stimulus"

// Manages individual page cache clearing from the page edit form
export default class extends Controller {
  static values = {
    url: String
  }

  static targets = ["message"]

  async clearCache(event) {
    event.preventDefault()

    if (!confirm("Are you sure you want to clear the cache for this page?")) {
      return
    }

    try {
      const response = await fetch(this.urlValue, {
        method: "DELETE",
        headers: {
          "X-CSRF-Token": this.csrfToken,
          "Accept": "application/json"
        }
      })

      if (response.ok) {
        const data = await response.json()
        this.showMessage("Page cache cleared successfully", "success")

        // Update the cache status text
        const statusElement = this.element.querySelector("p.text-sm")
        if (statusElement) {
          statusElement.innerHTML = `
            <span class="font-semibold text-yellow-700 dark:text-yellow-400">Not cached</span>
            - Will be cached on next visit
          `
        }
      } else {
        this.showMessage("Failed to clear page cache. Please try again.", "error")
      }
    } catch (error) {
      console.error("Page cache clear error:", error)
      this.showMessage("An error occurred while clearing the page cache.", "error")
    }
  }

  get csrfToken() {
    return document.querySelector('meta[name="csrf-token"]')?.content
  }

  showMessage(text, type = "info") {
    if (this.hasMessageTarget) {
      const alertClass = type === "error"
        ? "mt-2 rounded-md p-3 bg-red-50 dark:bg-red-900/20 border border-red-200 dark:border-red-800 text-red-800 dark:text-red-300"
        : "mt-2 rounded-md p-3 bg-green-50 dark:bg-green-900/20 border border-green-200 dark:border-green-800 text-green-800 dark:text-green-300"

      this.messageTarget.innerHTML = `
        <div class="${alertClass}">
          <p class="text-sm">${text}</p>
        </div>
      `

      setTimeout(() => {
        if (this.hasMessageTarget) {
          this.messageTarget.innerHTML = ""
        }
      }, 5000)
    }
  }
}